import { useTheme } from "@emotion/react";
import { Button, Stack, Typography } from "@mui/material"
import CenteredText from "components/CenteredText"
import Page from "components/Page"

import BgIc from "assets/images/ic_back.png"
import { Link } from "react-router-dom";
import { useHistory } from 'react-router'
import { useState } from "react";
import SimpleDialog from "components/SimpleDialog";
import ICLogo from "assets/images/ic_logo.svg"
import { Box } from "@mui/system";
import { useLazyRemote } from "lib/useRemote";

const ScopriIc = () => {
    const history = useHistory();
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [current, setCurrent] = useState(undefined);

    const { runCommand: runCommandSito } = useLazyRemote({ command: 'DOPO_SITO' })

    const openModal = (dest) => {
        setCurrent(dest);
        setOpen(true);
    }

    const onClose = () => {
        setOpen(false);
        setCurrent(undefined);
    }

    const onConfirm = (current) => {
        let win
        switch (current) {
            case "ic":
                win = window.open("http://innovationcenter.todo.com", "_blank");
                win.focus();
                runCommandSito()
                break;
            default:
                break;
        }
    }

    return (<Page syncNavCommand="IC_SLIDE" audioFile="/sounds/2.mp3">
        <Stack spacing={1} sx={{
            display: 'flex',
            flex: 1
        }}>
            <div style={{ backgroundImage: `url(${BgIc})`, height: '15rem', backgroundSize: 'cover' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <img src={ICLogo} alt="Innovation Center Logo" style={{ width: '90%' }} />
                </Box>
            </div>
            <Stack sx={{
                display: 'flex',
                flex: 1
            }}>

                <CenteredText>
                    <Button variant="contained" color="primary"
                        style={{ width: '100%' }} onClick={() => history.push('/democenter')}>
                        Cos’è Innovation Experience
                    </Button>
                </CenteredText>
                {
                    /*
<CenteredText>
                    <Button variant="contained" color="primary"
                        style={{ width: '100%' }} onClick={() => openModal('ic')}>
                        Visita il nostro sito
                    </Button>
                </CenteredText>

                    */
                }
                <CenteredText>
                    <Button variant="contained" color="primary"
                        style={{ width: '100%' }} onClick={() => history.push('/contatti_ic')}>
                        Rimani in contatto con noi
                    </Button>
                </CenteredText>
                <CenteredText>
                    <Link to="/scelta_iniziale">
                        <Typography variant="h6"
                            color={theme.palette.primary.main}
                            sx={{ textDecoration: 'underline' }}>
                            Torna alla Home Page
                        </Typography>
                    </Link>
                </CenteredText>
            </Stack>
        </Stack>
        <SimpleDialog
            open={open}
            title={"Stai per lasciare questa pagina per visitare un sito esterno, non tardare! Potresti perdere la priorità sul robot."}
            onConfirm={() => { onConfirm(current) }}
            onClose={() => onClose()}
        >
            <Typography>Ricordati di tornare su questa pagina
                per continuare l’esperienza con il
                robot Pepper.</Typography>
        </SimpleDialog>
    </Page >)
}
export default ScopriIc